import LocationSearchWithMap from '../comman/LocationSearchWithMap';

const AddressDetails = ({ formikProp }) => {
    const { values, setFieldValue, handleChange, touched, errors } = formikProp;
    const handleAddress = (address) => setFieldValue('address', { ...values.address, ...address });

    return (
        <>
            <div className="col-md-8">
                <div className="tabData">
                    <div className="">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>
                                        Select Address <span className="text-danger">*</span>
                                    </label>
                                    <div className="position-relative">
                                        <LocationSearchWithMap defaultAddress={values.address} onAddress={handleAddress} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4">
                <div className="card">
                    <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                            <button className="btn btn-link text-black shadow-none pl-0 pb-0 staturightghead">
                                Selected/Manually Address
                            </button>
                        </h5>
                    </div>

                    <div className="card-body">
                        <div className="form-group">
                            <label>
                                Province <span className="text-danger">*</span>
                            </label>
                            <input
                                name='address.state'
                                type="text"
                                className="form-control border"
                                placeholder="Enter Province"
                                value={values.address.state}
                                onChange={handleChange}
                            />
                            {touched?.address?.state && errors?.address?.state ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.address?.state}</span>
                            ) : ''}
                        </div>

                        <div className="form-group">
                            <label>
                                City <span className="text-danger">*</span>
                            </label>
                            <input
                                name='address.city'
                                type="text"
                                className="form-control border"
                                placeholder="Enter City"
                                value={values.address.city}
                                onChange={handleChange}
                            />
                             {touched?.address?.city && errors?.address?.city ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.address?.city}</span>
                            ) : ''}
                        </div>
                        <div className="form-group">
                            <label>
                                Street <span className="text-danger">*</span>
                            </label>
                            <input
                                name='address.street'
                                type="text"
                                className="form-control border"
                                placeholder="Enter Street"
                                value={values.address.street}
                                onChange={handleChange}
                            />
                             {touched?.address?.street && errors?.address?.street ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.address?.street}</span>
                            ) : ''}
                        </div>

                        <div className="form-group">
                            <label>
                                Address <span className="text-danger">*</span>
                            </label>
                            <textarea
                                name='address.addressLine1'
                                className="form-control border"
                                placeholder="Enter Address"
                                aria-rowcount={2}
                                value={values.address.addressLine1}
                                onChange={handleChange}
                            />
                             {touched?.address?.addressLine1 && errors?.address?.addressLine1 ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.address?.addressLine1}</span>
                            ) : ''}
                        </div>
                        <div className="form-group">
                            <label>
                                Pincode <span className="text-danger">*</span>
                            </label>
                            <input
                                name='address.pincode'
                                type="text"
                                className="form-control border"
                                placeholder="Enter Pincode"
                                value={values.address.pincode}
                                onChange={handleChange}
                            />
                             {touched?.address?.pincode && errors?.address?.pincode ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.address?.pincode}</span>
                            ) : ''}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AddressDetails